import React from 'react';
import classNames from 'classnames';
import { Text } from '../text';
import { Heading } from '../heading';
import styles from './section-navigation.module.scss';

interface Item {
  value: string;
  label: string;
}

export interface SectionNavigationProps {
  title: string;
  items: Item[];
  selected: string;
  onChange: (value: string) => void;
  className?: string;
}

export const SectionNavigation: React.FC<SectionNavigationProps> = ({
  title,
  items,
  selected,
  className,
  onChange
}) => {
  const baseClass = 'section-navigation';
  return (
    <div className={classNames(styles[`${baseClass}`], className)}>
      <Text variant="paragraph-100" className={styles[`${baseClass}__title`]}>
        {title}
      </Text>
      <ul className={styles[`${baseClass}__wrapper`]}>
        {items.map(({ label, value }) => {
          const isSelected = selected === value;
          return (
            <li key={value} className={styles[`${baseClass}__item`]}>
              <input
                className={styles[`${baseClass}__input`]}
                type="radio"
                value={value}
                name={value}
                defaultChecked={isSelected}
                key={value}
              />
              <button onClick={() => onChange(value)} className={styles[`${baseClass}__button`]}>
                <Heading
                  variant="headline-functional-100"
                  className={classNames(styles[`${baseClass}__item--text`], {
                    [styles[`${baseClass}__item--selected`]]: isSelected
                  })}
                >
                  {label}
                </Heading>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
